import { Banner, ModalBody, ModalFoot, Text } from '@dixa/lib-shared-habla';

import { AppLink } from 'components/appLink';

import { EndpointMessengersDisplay } from '../../../../../../components';
import {
  EndpointMessengers,
  FormUsage,
} from '../../../../../../customForms.types';

type Props = {
  endpointsMessengers: EndpointMessengers[];
  formUsages: FormUsage[];
  hide: () => void;
};

export function CannotDeleteForm({
  endpointsMessengers,
  formUsages,
  hide,
}: Props): JSX.Element {
  return (
    <>
      <ModalBody>
        <Banner
          variant="fail"
          headline="Can not delete form"
          description={
            <>
              <Text.Paragraph>
                Form is currently utilized by flows:
              </Text.Paragraph>
              <ul>
                {formUsages.map(({ flowId, flowChannel, flowTitle }) => (
                  <li key={flowId}>
                    <AppLink
                      path="/settings/dixa-messenger/flow/:flowId"
                      params={{ path: { flowId } }}
                      onClick={hide}
                    >
                      {flowChannel} {flowTitle}
                    </AppLink>
                  </li>
                ))}
              </ul>

              {endpointsMessengers.map((endpointMessengers) => (
                <EndpointMessengersDisplay
                  key={endpointMessengers.endpoint.id}
                  endpointMessengers={endpointMessengers}
                  onLinkClick={hide}
                />
              ))}
            </>
          }
        />
      </ModalBody>

      <ModalFoot cancelOnClick={hide} />
    </>
  );
}
